<template>
  <div class="event-card-head">
    <div class="d-flex">
      <el-checkbox v-model="conflictCodeChecked" v-if="item.TicketConflictCode" class="mr-2"/>
      <el-checkbox v-model="registrationLockedChecked" v-else-if="labels['registration-locked']" class="mr-2"/>
      <el-checkbox
          v-model="singleTicketOptionChecked"
          v-else-if="maxAvailableTickets === 1"
          class="mr-2"
      />

      <div class="event-card-avatar">
        <div class="event-initial-bg"></div>
        <div class="event-initial-text font-light">
          <img src="../../assets/icons/table.svg" alt="Table" v-if="item.TicketType === 'table'"/>
          <img src="../../assets/icons/user-icon.svg" alt="User" v-if="item.TicketType === 'individual'"/>
        </div>
      </div>
      <div class="event-card-title">
        <div class="event-individual-title">{{ item.TicketName }}</div>
        <div class="event-individual-price font-light">
          <template v-if="item.TicketPrice > 0">${{ item.TicketPrice.toLocaleString() }}</template>
          <template v-else>{{ labels['ticket-label-complimentary'] }}</template>
        </div>
      </div>
    </div>
    <template v-if="!labels['registration-locked']">
      <span v-if="maxAvailableTickets === 0" class="exhausted">Allocation exhausted</span>
      <div v-if="maxAvailableTickets > 1" class="event-qty-select">
        <el-select v-model="totalTicket">
          <el-option label="Select" value="0"></el-option>
          <el-option v-for="n in maxAvailableTickets" :key="n" :value="n" :label="n"></el-option>
        </el-select>
      </div>

    </template>
  </div><!-- /.event-card-head -->
</template>

<script>
export default {
  props: {
    id: {type: Number, required: true},
    item: {type: Object, required: true},
    labels: {type: Object, required: true},
    conflictCode: String,
    registrationLockedCode: String,
    tickets: Array,
    singleTicketOption: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      totalTicket: "0",
      conflictCodeChecked: false,
      registrationLockedChecked: false,
      singleTicketOptionChecked: false,
    }
  },
  mounted() {

    this.totalTicket = "0";

    // auto-select if only one ticket type is available
    if (this.singleTicketOption) {
      if (this.item?.TicketConflictCode) {
        this.conflictCodeChecked = true;
      }
      if (this.labels['registration-locked']) {
        this.registrationLockedChecked = true;
      } else {
        this.singleTicketOptionChecked = true;
      }
    }

    // if(this.item.TicketQtyAllowed === 1 && !this.item.TicketConflictCode && !this.labels['registration-locked'])
    // {
    //   this.totalTicket = 1;
    // }
    if (this.tickets) {
      let selectedItem;


      if (this.item.TicketType === 'table') {
        selectedItem = this.tickets.find(ticket => ticket.type === this.item.TicketType && ticket.code === this.item.FunctionCode && ticket.name === this.item.TicketName);
      } else {
        selectedItem = this.tickets.find(ticket => ticket.type === this.item.TicketType && ticket.code === this.item.FunctionCode);
      }

      if (selectedItem) {
        this.totalTicket = selectedItem.value.toString();
        console.log(selectedItem.value.toString())
        if (selectedItem.type === 'table') {
          this.conflictCodeChecked = true;
        }
      }

    }
  },
  computed: {
    ticketConflictCode: function () {
      return `${this.item.TicketConflictCode}-${this.id}`;
    },
    maxAvailableTickets() {
      if (this.item.TicketType === 'table') {
        return parseInt(this.item.TicketQtyAllowed)
      }

      return this.item.TicketQtyAllowed > 1 ?
          Math.min(parseInt(this.labels.MaxIndividualQty), parseInt(this.item.PlacesRemaining))
          : parseInt(this.labels.MaxIndividualQty)
    }
  },
  watch: {
    conflictCode: function (val) {
      if (this.item.TicketConflictCode && this.ticketConflictCode !== val) {
        this.conflictCodeChecked = false;
        this.totalTicket = "0";
      }
    },
    registrationLockedCode: function (val) {
      if (val !== this.item.FunctionCode) {
        this.registrationLockedChecked = false;
        this.totalTicket = "0";
      }
    },
    totalTicket: function (val) {
      if (!this.item.TicketConflictCode || (this.item.TicketConflictCode && this.conflictCodeChecked)) {
        if (val === "0" && this.item.TicketConflictCode && this.conflictCodeChecked) {
          this.$emit('checked-conflict-code', '');
        }
        this.updateNumberOfTicket(val);
      }

      this.conflictCodeChecked = val !== "0";
    },
    singleTicketOptionChecked: function (val) {
      const ticketsSelected = val ? '1' : '0';
      this.updateNumberOfTicket(ticketsSelected);
    },
    registrationLockedChecked: function (val) {
      if (val) {
        this.updateNumberOfTicket("1");
        this.$emit('checked-registration-locked', this.item.FunctionCode);
      }
    },
    conflictCodeChecked: function (val) {
      if (val) {
        this.$emit('checked-conflict-code', this.ticketConflictCode);

        if (this.totalTicket === "0") {
          this.totalTicket = "1";
        } else {
          this.updateNumberOfTicket(this.totalTicket);
        }
      } else if (this.ticketConflictCode === this.conflictCode) {
        this.$emit('checked-conflict-code', '');
        this.updateNumberOfTicket("0");
      }
    }
  },
  methods: {
    updateNumberOfTicket: function (val) {
      this.$emit(
          'select-number-of-ticket',
          {
            code: this.item.FunctionCode,
            conflictCode: this.item.TicketConflictCode,
            name: this.item.TicketName,
            type: this.item.TicketType,
            price: this.item.TicketPrice,
            value: val,
            registrationLocked: this.labels['registration-locked'],
          }
      );
    }
  }
}
</script>

